import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { FaqOption } from "../types";

interface FaqSelectorProps {
  selectedOps: string;
  onSelectOps: (value: string) => void;
  options: FaqOption[];
}

export function FaqSelector({
  selectedOps,
  onSelectOps,
  options,
}: FaqSelectorProps) {
  const dividerOptions = options.filter((opt) => opt.type === "divider");
  const regularOptions = options.filter((opt) => !opt.type);

  return (
    <Select value={selectedOps} onValueChange={onSelectOps}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Selecione uma operação" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {dividerOptions.map((divider) => (
            <SelectLabel key={divider.key}>{divider.value}</SelectLabel>
          ))}
          {regularOptions.map((option) => (
            <SelectItem key={option.key} value={option.key}>
              {option.value}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
